import { useDataValue } from 'Simple/Data.js'
import useStableValue from 'Logic/useStableValue.js'

/** @type {import('Simple/types.js').useDataConfiguration} */
export default function useDataConfiguration(props, data) {
  let location_id = useDataValue({
    context: 'tab',
    path: 'selected.location_id',
    viewPath: props.viewPath,
  })

  let selected_filters = useDataValue({
    context: 'tab',
    path: 'selected.filters',
    viewPath: props.viewPath,
  })

  let { automation_type, search_term, type, value_to, appointment_type_ids } =
    selected_filters
  let stable_search_term = useStableValue(search_term)

  let filters = [
    { organization_id: { _eq: location_id } },
    automation_type && { automation_type: { _eq: automation_type } },
    stable_search_term && { name: { _ilike: `%${stable_search_term}%` } },
    type && { type: { _eq: type } },
    (value_to.length > 0 || appointment_type_ids.length > 0) && {
      _and: [
        value_to.length > 0 && { data: { _contains: { value_to } } },
        appointment_type_ids.length > 0 && {
          data: { _contains: { appointment_type_ids } },
        },
      ].filter(Boolean),
    },
  ]
    .filter(Boolean)
    .reduce((acc, value) => ({ ...acc, ...value }), {})

  return {
    variables: {
      filters: filters,
    },
    pause: !location_id,
  }
}
